import React from 'react';
import { Stack } from '@pairy/pds-react';

const Root = ({ children }: React.PropsWithChildren) => {
  return (
    <Stack direction="column" gap={16} marginBottom={56}>
      {children}
    </Stack>
  );
};

export default Root;
